import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconCircleFilled(props: IconProps) {
	return (
		<Icon fill="currentColor" {...props}>
			<path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" />
		</Icon>
	);
}
